export const cdnBucketPrefix = 'https://d2hrw3sjxwwsb1.cloudfront.net'

export const about543Img1 = `${cdnBucketPrefix}/img/pic-about543/about543-img-1.jpg`
export const about543Img2 = `${cdnBucketPrefix}/img/pic-about543/about543-img-2.jpg`
export const cabinetBanner = `${cdnBucketPrefix}/img/mobile/Banner-fin.jpg`
export const bottomRabbit = `${cdnBucketPrefix}/img/mobile/rabbit_bottom.png`
export const plamboxHowtoUse1 = `${cdnBucketPrefix}/img/mobile/plamboxHowtoUse1.jpg`
export const main1Pic = `${cdnBucketPrefix}/img/mobile/usage-1.jpg`
export const main2Pic = `${cdnBucketPrefix}/img/mobile/usage-2.jpg`
export const main3Pic = `${cdnBucketPrefix}/img/mobile/usage-3.jpg`
export const main4Pic = `${cdnBucketPrefix}/img/mobile/usage-4.jpg`
export const main5Pic = `${cdnBucketPrefix}/img/mobile/usage-5.jpg`
export const loveboxBanner = `${cdnBucketPrefix}/img/mobile/banner.jpg`
export const explainImg = `${cdnBucketPrefix}/img/mobile/explain.png`
export const isPresentImg = `${cdnBucketPrefix}/img/mobile/is_present.png`
export const give543Logo = `${cdnBucketPrefix}/img/mobile/logo-square-white.jpg`
export const logoImg = `${cdnBucketPrefix}/img/mobile/logo-transparent.png`
export const orderTopBg = `${cdnBucketPrefix}/img/mobile/order_top_bg@2x.png`
export const titleRabbit = `${cdnBucketPrefix}/img/mobile/rabbit_title.png`
export const picLoadingGif = `${cdnBucketPrefix}/img/mobile/com_pic_loading_new.gif`
